$('.press__item').on('mouseenter', function (e) {
    $(document).find('.press__item').not($(this)).addClass('press__item_hov');
});

$('.press__item').on('mouseleave', function (e) {
    $(document).find('.press__item').removeClass('press__item_hov');
});